import { render, staticRenderFns } from "./IconTriangleRight.vue?vue&type=template&id=28692172&"
import script from "./IconTriangleRight.vue?vue&type=script&lang=js&"
export * from "./IconTriangleRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports